export enum SRSBuilderMode {
    CREATE,
    EDIT,
}
